<template>
    <div id="modules_and_modalities-dropdown" class="dropdown mb-0 mb-md-0 mt-0" style="width: 100%; padding-top: 50px;">
        <div class="scroll-container" style="overflow-y: auto">
            <div class="d-flex flex-wrap flex-column modules-container pr-0">
                <div class="select-all">
                    <div class="form-check form-check-inline">
                        <input
                            id="modules_and_modalities_select_all"
                            class="form-check-input"
                            type="checkbox"
                            :checked="value.select_all"
                            @change="$emit('select-all', $event.target.checked)"
                        />
                        <label class="form-check-label" for="modules_and_modalities_select_all">
                            TODOS
                        </label>
                    </div>
                </div>
                <ul class="mb-0" v-for="module in parsed_modules" :key="module.id">
                    <li class="mb-0 list-unstyled">
                        <div class="d-flex justify-content-between position-relative module-row">
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="'ChkModule_' + module.id"
                                    :name="'ChkModule_' + module.id"
                                    :checked="value[`module_${module.id}`]?.selected"
                                    @change="$emit('module-change', $event, module.id)"
                                />
                                <label class="form-check-label" :for="'ChkModule_' + module.id">
                                    {{ module.name }}
                                </label>
                            </div>
                            <div class="chevron-expand-container" @click="$emit('toggle-expand', 'module', module.id)">
                                <i class="chevron-expand fa fal"
                                    :class="{
                                        'fa-chevron-right': !value[`module_${module.id}`]?.expanded,
                                        'fa-chevron-down': value[`module_${module.id}`]?.expanded,
                                    }">
                                </i>
                            </div>
                        </div>

                        <div class="mb-0 collapse"
                            :id="'collapse_' + module.id"
                            :class="{ show: value[`module_${module.id}`]?.expanded }"
                        >
                            <ul v-for="modality in module.modalities" :key="modality.id">
                                <li class="list-unstyled ml-0 mb-0">
                                    <div class="d-flex justify-content-between position-relative modality-row">
                                            <div class="form-check form-check-inline">
                                            <input
                                                class="form-check-input modality-checkbox"
                                                type="checkbox"
                                                :id="'ChkModality_' + modality.id"
                                                :name="'ChkModality_' + modality.id"
                                                :value="modality.id"
                                                :checked="value[`module_${module.id}`]?.modalities.includes(modality.id)"
                                                @change="$emit('modality-change', $event, module.id, modality.id)"
                                            />
                                            <label class="p-0 form-check-label modality-label" :for="'ChkModality_' + modality.id">
                                                {{ modality.name }}
                                            </label>
                                        </div>

                                        <div class="chevron-expand-container modality-chev" @click="$emit('toggle-expand', 'modality', modality.id)">
                                            <i class="chevron-expand fa fal"
                                                :class="{
                                                    'fa-chevron-right': !value[`modality_${modality.id}`]?.expanded,
                                                    'fa-chevron-down': value[`modality_${modality.id}`]?.expanded,
                                                }">
                                            </i>
                                        </div>
                                    </div>

                                    <div class="mb-0 collapse"
                                        :id="'collapse_modality_' + modality.id"
                                        :class="{ show: value[`modality_${modality.id}`]?.expanded }"
                                    >
                                        <ul v-for="schedule in modality.schedules" :key="schedule.id">
                                            <li class="list-unstyled ml-0 mb-0">
                                                <div class="d-flex justify-content-between position-relative schedule-row">
                                                    <div class="form-check form-check-inline">
                                                        <input
                                                            class="form-check-input schedule-checkbox"
                                                            type="checkbox"
                                                            :id="'ChkSchedule_' + schedule.id"
                                                            :name="'ChkSchedule_' + schedule.id"
                                                            :value="schedule.id"
                                                            :checked="value[`modality_${modality.id}`]?.schedules?.includes(schedule.id)"
                                                            @change="$emit('schedule-change', $event, module.id, modality.id, schedule.id)"
                                                        />
                                                        <label class="p-0 form-check-label schedule-label" :for="'ChkSchedule_' + schedule.id">
                                                            {{ schedule.nome.toUpperCase() }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    name: 'ModulesModalitiesAndSchedulesSelector',
    props: {
        modules: { 
            type: Array, 
            default: () => [] 
        },
        modalities: { 
            type: Array, 
            default: () => [] 
        },
        schedules: { 
            type: Array, 
            default: () => [] 
        },
        value: { 
            type: Object, 
            default: () => ({}) 
        }
    },
    computed: {
        parsed_modules() {
            return _.sortBy(this.modules, 'name').map((module) => ({
                ...module,
                modalities: _.sortBy(
                    this.modalities
                        .filter((m) => m.module_id == module.id)
                        .map((modality) => ({
                            ...modality,
                            schedules: _.sortBy(this.schedules.filter((s) => s.modality_id == modality.id), 'nome')
                        })),
                    'name'
                ),
            }))
        }
    },
}
</script>

<style scoped>
.select-all {
    padding-left: 12px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--borderColor);
}

.chevron-expand-container {
    position: absolute;
    right: 0;
    top: 0;
    width: calc(100% - 34px);
    height: 32.02px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: end;
}

.modality-chev {
    width: calc(100% - 73px);
    top: 0;
    right: 0;
}

#modules_and_modalities-dropdown {
    max-height: 950px !important;
    display: flex;
    flex-direction: column;
}

.form-check-label {
    font-size: 17px;
    color: var(--titleFontColor);
    padding-left: 16px;
    border-radius: 0.1rem;
    font-weight: 500;
}

.form-check-label::before {
    border-radius: 0.1rem;
    border: 1px solid var(--checkboxBorderColor);
    background: var(--checkboxBackground);
}

.form-check-inline {
    width: 100%;
    margin-right: 0;
}

.module-row, .modality-row, .schedule-row {
    background: var(--sideBarBackgroundColor);
    border-bottom: 1px solid var(--borderColor);
    padding: 6px 12px;
    align-items: center;
}

.module-row {
    height: 40px;
}

.modality-row {
    height: 36px;
    padding-left: 50px;
}

.schedule-row {
    height: 35px;
    padding-left: 89px;
}

.form-check-input {
    width: 18px;
    height: 18px;
    transform: none;
}

.form-check input:checked ~ label:after {
    background: #1e3a8a;
    border-radius: 0.1rem;
}

.module-row:hover, .modality-row:hover, .schedule-row:hover {
    background: var(--sideBarHoverBackground);
}

.chevron-expand {
    margin-left: 6px;
    padding-right: 12px;
    color: var(--chevronExpandColor);
}

.chevron-expand.fa-chevron-down {
    color: var(--chevronExpandDownColor);
}

.modality-label {
    font-size: 16px;
    font-weight: 600;
    color: var(--modalityLabelColor);
    padding-left: 16px !important;
}

.schedule-label {
    font-size: 14px;
    color: var(--scheduleLabelColor);
    font-weight: 600;
    padding-left: 16px !important;
}

.scroll-container {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 10px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    color: var(--titleFontColor);
    padding: 10px;
    margin: 0;
}
</style>
